import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { ErrorModel } from "../../interfaces/error-model";
import { ErrorActions } from "../actions";

@Injectable({
    providedIn: "root",
})
export class ErrorFacade {
    private readonly store = inject(Store);

    onShowError(error: ErrorModel): void {
        this.store.dispatch(ErrorActions.otherError({ error }));
    }
}
